import { __awaiter, __generator } from "tslib";
import { call } from './call';
export var setNavbar = function (params) {
    var isShow = params.isShow;
    return call('SKHandle', 'handleNavBar', { isShow: isShow ? '1' : '0' });
};
export var setScreen = function (params) {
    var orientation = params.orientation;
    return call('SKHandle', 'handleOrientation', { orientation: orientation });
};
export var setStatusBarStyle = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var statusBarAppearance;
    return __generator(this, function (_a) {
        statusBarAppearance = params.style;
        return [2 /*return*/, call('SKHandle', 'handleStatusBarAppearance', { statusBarAppearance: statusBarAppearance })];
    });
}); };
